














































































































































import { Route } from 'vue-router'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import { filterQueryParams } from '@/utils'
import { TabSettingName, Tabs } from '@/constants/appSettings'
import VitalsignModal, {
  Props as ModalProps
} from '@/components/managePatient/VitalsignModal.vue'

enum ManualInputOptions {
  VITAL = 1
}

enum OtherImportOptions {
  DICOM = 1,
  VITALSIGN,
  IMAGE,
  DOCUMENT,
  PRESCRIPTION,
  DISPENSATION
}

@Component({
  components: {
    ControlTable: () => import('@/components/ControlTable.vue'),
    Paginate: () => import('@/components/Paginate.vue'),
    UserIcon: () => import('@/components/common/UserIcon.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue'),
    FileInput: () => import('@/components/common/inputs/FileInput.vue'),
    VitalsignModal
  }
})
export default class ManagePatient extends Vue {
  @Prop(Number) readonly page!: number | undefined
  @Prop(String) readonly query!: string

  $store!: ExStore
  searchKeyword!: string
  modalOpenedSelect!: HTMLSelectElement
  pending = true

  selectImportLabotest = false
  inputImportLabotest = ''
  errorImportLabotest = ''
  pendingImportLabotest = false

  manualInputOptions = [
    { label: '直接入力', value: -1 },
    { label: 'バイタル', value: ManualInputOptions.VITAL }
  ]
  otherImportOptions = [
    { label: '取込', value: -1 },
    { label: 'バイタル', value: OtherImportOptions.VITALSIGN },
    { label: '医用画像', value: OtherImportOptions.DICOM },
    { label: 'その他画像', value: OtherImportOptions.IMAGE },
    { label: '文書類', value: OtherImportOptions.DOCUMENT },
    // { label: '処方箋', value: OtherImportOptions.PRESCRIPTION },
    { label: '調剤QR', value: OtherImportOptions.DISPENSATION }
  ]

  modalShow = false
  modalProps: ModalProps = {
    patient: undefined,
    measureDatetime: undefined
  }

  get patientIds() {
    return this.$store.getters['patient/sort']
  }

  get patients() {
    return this.$store.getters['patient/patients']
  }

  get totalCount() {
    return this.$store.getters['patient/totalCount'] || 0
  }

  get patientCount() {
    return Object.keys(this.patients || {}).length
  }

  get paginateQueryParams() {
    return filterQueryParams({ query: this.query })
  }

  get hasMultiplePages() {
    return this.totalCount > this.patientCount
  }

  get tabSettings() {
    return this.$store.getters['appSettings/displayTabs']
  }

  getWorkers(ids: number[]) {
    return this.$store.getters['worker/workersById'](ids || [])
  }

  handleKeywordSearch() {
    this.$router.push({
      name: 'ManagePatient',
      query: filterQueryParams({
        page: String(this.page || ''),
        query: this.searchKeyword
      })
    })
  }

  loadPatients(page: number, query?: string) {
    this.pending = true
    return this.$store
      .dispatch('patient/updateList', { page, query, archived: false })
      .then(() => {
        this.pending = false
        this.$store.dispatch('worker/updateList', {
          patientIds: this.patientIds
        })
      })
  }

  @Watch('inputImportLabotest')
  async handleChangeImportLabotest(data: string) {
    if (this.pendingImportLabotest) {
      return
    }

    this.pendingImportLabotest = true
    this.errorImportLabotest = ''

    if (!data) {
      return
    }

    try {
      await this.$store.dispatch('labotest/create', {
        data,
        validateOnly: true
      })
      this.$store.commit('user/setSessionData', { labotest: data })
      this.$router.push({ name: 'LabotestImportConfirm' })
    } catch (error) {
      this.errorImportLabotest = 'データの送信に失敗しました。'
    } finally {
      this.pendingImportLabotest = false
    }
  }

  async handleClickPreRegist(id: number) {
    const { email } = this.patients[id]
    const { registrationUrl } = await this.$api.user.fetchPatientRegistration({
      patientId: id
    })
    this.$store.commit('user/setSessionData', {
      createdPatient: {
        id,
        email,
        registrationUrl
      }
    })
    this.$router.push({ name: 'ManagePatientAddComplete' })
  }

  handleSelectManualInput(event: Event, patientId: number) {
    const value = (event.target as HTMLInputElement).value
    const params = { patientId: String(patientId) }

    switch (Number(value)) {
      case ManualInputOptions.VITAL:
        this.$router.push({
          name: Tabs[TabSettingName.vitalSign].routeName,
          params
        })
        break
      default:
        break
    }
  }

  handleSelectOtherImport(event: Event, patientId: number) {
    const input = event.target as HTMLSelectElement
    const value = input.value
    const params = { patientId: String(patientId) }

    switch (Number(value)) {
      case OtherImportOptions.VITALSIGN:
        this.modalProps.patient = this.patients[patientId]
        this.modalProps.measureDatetime = dayjs().format('YYYY-MM-DD HH:mm')
        this.modalShow = !this.modalShow
        this.modalOpenedSelect = input
        break
      case OtherImportOptions.DICOM:
        this.$router.push({
          name: Tabs[TabSettingName.dicom].routeName + 'Upload',
          params
        })
        break
      case OtherImportOptions.IMAGE:
        this.$router.push({
          name: Tabs[TabSettingName.image].routeName + 'Upload',
          params
        })
        break
      case OtherImportOptions.DOCUMENT:
        this.$router.push({
          name: Tabs[TabSettingName.document].routeName + 'Upload',
          params
        })
        break
      case OtherImportOptions.PRESCRIPTION:
        this.$router.push({
          name: Tabs[TabSettingName.prescription].routeName,
          params
        })
        break
      case OtherImportOptions.DISPENSATION:
        this.$router.push({
          name: Tabs[TabSettingName.dispensation].routeName,
          params
        })
        break
      default:
        break
    }
  }

  handleClickPatientId(patientId: number) {
    const params = { patientId: String(patientId) }
    this.$router.push({
      name:
        Tabs[
          this.tabSettings.filter(tab => tab.isActive)[0].name as TabSettingName
        ].routeName,
      params
    })
  }

  handleCloseModal() {
    if (this.modalOpenedSelect) {
      this.modalOpenedSelect.value = '-1'
    }
    this.modalShow = false
  }

  created() {
    const page = this.page || 1
    const query = this.query
    this.searchKeyword = query
    this.$store.commit('patient/clear')
    this.loadPatients(page, query)
  }

  beforeRouteUpdate(to: Route, from: Route, next: Function) {
    const page = Number(to.query.page || 1)
    const query = typeof to.query.query === 'string' ? to.query.query : ''
    this.$store.commit('patient/clear')
    this.loadPatients(page, query)
    next()
  }
}
